import useSWR from 'swr'

import { useCallMutation } from '@/common/api/client'
import { apiPutFetcher } from '@/common/api/fetcher'
import {
  GetMediaAiTrainingDataVars,
  MediaAiTrainingDataApiPath,
  UpdateMediaAiTrainingDataVars
} from '@/common/api/params/mediaAiTrainingData'
import { MediaAiTrainingData } from '@/common/model/media/mediaAiTrainingData'

export const useMediaAiTrainingDataApi = (vars: GetMediaAiTrainingDataVars | undefined) => {
  return useSWR<MediaAiTrainingData, Response, [string, GetMediaAiTrainingDataVars] | undefined>(
    vars ? [MediaAiTrainingDataApiPath.GET, vars] : undefined
  )
}

export const useUpdateMediaAiTrainingDataApi = (options?: {
  onSuccess?: (response: MediaAiTrainingData) => void
  onError?: (error: Response) => void
}) => {
  return useCallMutation<MediaAiTrainingData, UpdateMediaAiTrainingDataVars>(
    MediaAiTrainingDataApiPath.UPDATE,
    { ...options },
    apiPutFetcher
  )
}
